<template functional>
  <v-flex xs12 class="round" style="text-align:left;background:#fff;padding:16px 16px 1px 16px;">
    <h2>カラログとは</h2>
    <p>カライモノを食べた記録や食品に対する口コミ、感想を気軽に残すことができます。自分だけの日々の辛いものの記録や、はじめて食べた辛いもののレビュー、おすすめな食べ物の情報などなどぜひお気軽に投稿してみてください！</p>
    <p style="text-align:center">
      <v-btn color="primary" dark large :to="{name: 'reviewPostSearchFood'}">
        <v-icon>edit</v-icon>カラログ投稿
      </v-btn>
    </p>
    <p>YoutubeとTwitterの埋め込みもできるようになりました。</p>
  </v-flex>
</template>

<script>
export default {
  name: 'KaralogInfo'
}
</script>

<style scoped>
  .round {
    border-radius:10px
  }
</style>